import { Typography, Grid, Box, Divider, CircularProgress } from '@mui/material';
import styles from './styles';
import Premium from '../../assets/images/PRO logo PMS green only.svg';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ORDER_STATUS_TYPES, ORDER_STATUS_ACTIONS, ORDER_STATUS_SUMBITTED } from '../../shared/config/constants';
import { checkOrderStatus, postOrderStatus } from '../../store/actions/orders';
import { useDispatch } from 'react-redux';
import { useAuth } from '../../hooks/useAuth';
import ConfirmStatusUpdateDialog from '../ui/ConfirmStatusUpdateDialog';

export default function OrderStatus() {
  const classes = styles();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { onLogout } = useAuth();
  const [data, setData] = useState({});
  const [status, setStatus] = useState({
    loading: false,
    error: false,
    confirmed: false
  });
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    status: null
  });

  const verifyData = (data) => {
    const isVerified = Object.values(data).every(item => item);
    return isVerified;
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const data = {
      userId: searchParams.get('userId'),
      type: searchParams.get('type'),
      status: searchParams.get('orderStatus'),
      key: searchParams.get('key'),
      approverEmail: searchParams.get('approverEmail'),
      orderNumber: searchParams.get('orderNumber')
    };

    if (!verifyData(data) || !/^[0-9A-Fa-f]+$/.test(data?.userId)) {
      navigate('/Login');
    } else {
      setData(data);
      setStatus({
        ...status,
        loading: true
      });
      dispatch(checkOrderStatus({
        type: searchParams.get('type'),
        approverEmail: searchParams.get('approverEmail'),
        orderNumber: searchParams.get('orderNumber')
      }, data.key, (orderStatusSubmitted) => {
        if (!orderStatusSubmitted) {
          setStatus({
            ...status,
            loading: false
          });
          setConfirmDialog({
            open: true,
            status: data?.status
          });
        } else {
          setStatus({
            loading: false,
            error: false,
            confirmed: true,
            orderStatusSubmitted: true
          });
          setConfirmDialog({
            open: false,
            status: orderStatusSubmitted
          });
        }
      }));
    }
  }, [location.search]);

  const handleConfirm = () => {
    setStatus({
      ...status,
      loading: true
    });
    const body = { input: { ...data, status: confirmDialog?.status } };
    dispatch(postOrderStatus(body, data.key, setStatus));
    setConfirmDialog({
      open: false,
      status: confirmDialog?.status
    });
  };

  const OptionsComponent = () => {
    return (
      <Box>
        <Box className={classes.orderText}>
          {`${data?.orderNumber}`}
        </Box>
        <Box className={classes.actionContainer} >
          {Object.entries(ORDER_STATUS_ACTIONS).map(([key, value]) => (
            <Box
              key={key}
              className={classes.actionButton}
              onClick={() => setConfirmDialog({
                open: true,
                status: key
              })}
            >{value}</Box>
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <Grid sx={{ height: '100vh' }} container justifyContent="center">
      <Grid item container xs={12} justifyContent="center">
        <Box
          component="img"
          alt="Logo"
          src={Premium}
          className={classes.logo}
        />
        <Divider className={classes.divider}/>
      </Grid>
      {status?.loading
        ? (
          <Grid sx={{ height: '65vh' }} item container xs={12} justifyContent="center" alignItems="center" flex flexDirection={'column'}>
            <CircularProgress />
          </Grid>
          )
        : (
          <Grid sx={{ height: '65vh' }} item container xs={12} justifyContent="center" alignItems="center" flex flexDirection={'column'}>
            <Typography variant={status?.error ? 'h4' : 'h2'} className={classes.text}>
            {status?.error ? status?.errorMessage : status?.orderStatusSubmitted ? `Order status has already been set to ${ORDER_STATUS_SUMBITTED[confirmDialog?.status]} for ${data?.orderNumber}` : status?.confirmed ? `Thank You for ${ORDER_STATUS_TYPES[confirmDialog?.status]} ${data?.orderNumber}` : ''}
            </Typography>
            {!status?.confirmed && <OptionsComponent />}
            <Typography onClick={onLogout} variant="h3" className={classes.link}>
              Sign Into Marketplace
            </Typography>
          </Grid>
          )}
      {confirmDialog.open
        ? (
          <ConfirmStatusUpdateDialog
            open={confirmDialog.open}
            handleClose={() => {
              setConfirmDialog({
                open: false,
                status: null
              });
            }}
            selectedData={{
              orderNumber: data.orderNumber,
              status: confirmDialog.status,
              id: data.id
            }}
            handleConfirm={handleConfirm}
          />
          )
        : null}
    </Grid>
  );
}
